import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  selectOrgContainer: {
    height: '100%',
    width: '100%'
  }
}));

export default useStyles;
